export const CHANNEL_ID = '100122'
export const WX_CHANNEL_ID = '100124'
export const SY_CHANNEL_ID = '100123'

export const RES_OK = 10000
export const RES_SESSION_EXPIRED = -90001 // session失效
export const title = '测试项目'
export const homeName = 'home'
import axios from 'axios'
// export const IMG_SERVE_URL = 'http://sdxpos.oss-cn-shanghai.aliyuncs.com/'
// export const IMG_SERVE_URL = 'https://hyunst.oss-cn-shanghai.aliyuncs.com/'
export const IMG_SERVE_URL = 'https://upyun-cdn.hyunst.com/'
// file.hyunst.com  8243
const getImgUploadUrl = dataType => {
  let protocol = window.location.protocol
  if (dataType === '1') {
    if (protocol === 'https:') {
      return 'https://file.hyunst.com:8243/fileServer/servlets/UploadFileServlet?urlType=upyun&dataType=base64_upyun'
      // return 'https://file.hyunst.com:8243/fileServer/servlets/UploadFileServlet?rootFilePath=image&urlType=upyun&dataType=base64_upyun'
    } else {
      return 'http://file.hyunst.com:8082/fileServer/servlets/UploadFileServlet?urlType=upyun&dataType=base64_upyun'
    }
  } else {
    if (protocol === 'https:') {
      return 'https://file.hyunst.com:8243/fileServer/servlets/UploadFileServlet?urlType=upyun&dataType=file_upyun'
    } else {
      return 'http://file.hyunst.com:8082/fileServer/servlets/UploadFileServlet?urlType=upyun&dataType=file_upyun'
    }
  }
}
export const UPLOAD_IMG_SERVER_URL = getImgUploadUrl('1')
export const UPLOAD_IMG_file_SERVER_URL = getImgUploadUrl('2')
// export const UPLOAD_IMG_SERVER_URL =
//   'http://file.hyunst.com:8082/fileServer/servlets/UploadFileServlet?rootFilePath=image&urlType=upyun&dataType=base64_upyun'
// 'http://192.168.1.20:8079/hy_file_server/servlets/UploadFileServlet?rootFilePath=image&urlType=upyun&dataType=base64_upyun'
// 'http://file.hyunst.com:8082/fileServer/servlets/UploadFileServlet?x-gmkerl-thumb=/quality/80&maxSize=10&rootFilePath=image&urlType=upyun&dataType=base64_upyun'
// 'http://file.hyunst.com:8082/fileServer/servlets/UploadFileServlet?rootFilePath=image&urlType=aliyun&dataType=base64'
// 'http://file.sdxpos.com:8082/fileServer/servlets/UploadFileServlet?maxSize=10&rootFilePath=image&urlType=aliyun&isCompress=1&dataType=base64'
export const UPLOAD_GIF_SERVER_URL =
  'https://wx.hyunst.com/fileServer/servlets/UploadFileServlet?maxSize=10&rootFilePath=image&urlType=aliyun&isCompress=0&dataType=base64'
// 'https://wx.sdxpos.com/fileServer/servlets/UploadFileServlet?maxSize=10&rootFilePath=image&urlType=aliyun&isCompress=0&dataType=base64'
export const cookieExpires = 1
export const useI18n = true

const getRootUrl = flag => {
  const proUrl = 'http://ht.hyunst.com' // 生产环境
  // const devUrl = 'http://ht.hyunst.com/hy_ht/' // 本地开发环境
  const devUrl = 'http://test.hyunst.com/ht/' // 本地开发环境
  // const devUrl = 'http://localhost:8080/hy_ht/'
  // const devUrl = 'http://192.168.1.17:8080/hy_ht'
  const curUrl = 'http://' + window.location.host
  let rootUrl
  if (flag) {
    axios.defaults.withCredentials = true
    const url = document.location.pathname
    const itmp = url.indexOf('/', 1)
    let webpath = itmp < 0 ? url : url.substr(0, itmp)
    if (webpath.indexOf('/') === -1) {
      webpath = '/' + webpath
    }
    if (curUrl.indexOf(proUrl) > -1) {
      webpath = ''
    }
    const protocol = window.location.protocol
    const host = window.location.host
    rootUrl = protocol + '//' + host + webpath + '/'
  } else {
    rootUrl = devUrl
  }
  return rootUrl
}
export const SERVER_BASE_URL = getRootUrl(process.env.NODE_ENV === 'production')

export const ORDER_SRC_ICON = {
  1: 'icondiannao font-color-primary',
  8: 'icondiannao font-color-primary',
  2: 'iconweixin font-color-success',
  6: 'iconweixin font-color-success',
  5: 'iconumidd17 font-color-success',
  9: 'iconjifenduihuan font-color-warning',
  10: 'iconqq'
}

/** ****** xsd start ************* **/
// salesMode 销售方式(1:份,2:件,3:套,4:KG)
export const SALES_MODE = {
  1: '份',
  2: '件',
  3: '套',
  4: 'kg',
  5: 'g'
}
// 折扣类型(1:折扣率有效,2:折扣价有效,3:降价有效)
export const DISCOUNT_TYPE_NAME = {
  1: '折扣率',
  2: '折扣价',
  3: '降价'
}
export const PAY_CHANNEL = {
  ZFB: '支付宝',
  WX: '微信',
  CZ: '储值'
}
export const LOADING_TEXT = '拼命加载中...'
// activityState 状态(-1:操作中,0:未开启,1:已开启,2:停止,3:作废)
export const ACTIVITY_STATE_NAME = {
  '-1': '操作中',
  '0': '未开启',
  '1': '已开启',
  '2': '已停止',
  '3': '已作废'
}
// activityType 活动类型(JZYX:精准营销,WXLQ:微信领券,XFFQ:消费返券,XHYZX:新会员专享,
// CZGZ:储值规则,ZKSP:折扣商品,JFSP:积分商品,YXK:营销卡,ZKYX:折扣营销(买N赠N))
export const ACTIVITY_TYPE = {
  JZYX: 'JZYX',
  WXLQ: 'WXLQ',
  XFFQ: 'XFFQ',
  XHYZX: 'XHYZX',
  CZGZ: 'CZGZ',
  ZKSP: 'ZKSP',
  JFSP: 'JFSP',
  YXK: 'YXK',
  ZKYX: 'ZKYX'
}
// 卡说明内容长度限制
export const CARD_EXPLAINCONTENT_MAXLEN = 500
// 卡名称长度限制
export const CARD_NAME_MAXLEN = 15
// 预约时间收费单位
export const TIME_UNIT_Name = {
  1: '年',
  2: '月',
  3: '天',
  4: '小时',
  5: '分钟',
  6: '秒'
}
// 电子券类型(1:通用券,2:商品优惠券,3:服务优惠券)
export const TICKET_TYPE_NAME = {
  1: '通用券',
  2: '商品优惠券',
  3: '服务优惠券',
  5: '预约优惠券'
}
// 金额单位(1:元,2:角,3:分)
export const TICKET_MONEY_UNIT_NAME = {
  1: '元',
  2: '角',
  3: '分'
}
export const MP_IMG_JUMP = [
  // 小程序图片跳转
  {
    pathType: 1,
    name: '注册会员'
  },
  {
    pathType: 2,
    name: '引导充值'
  },
  {
    pathType: 3,
    name: '引导购卡'
  },
  {
    pathType: 4,
    name: '指定商品'
  },
  {
    pathType: 5,
    name: '商品分类'
  },
  {
    pathType: 6,
    name: '积分商城'
  },
  {
    pathType: 7,
    name: '领券中心'
  },
  {
    pathType: 8,
    name: '分享页'
  },
  {
    pathType: 9,
    name: '分销页'
  },
  {
    pathType: 10,
    name: '自定义'
  }
]
export const OVERLORD_AGENT_API_LIST = [
  'addStaff',
  'updateStaff',
  'addSupplierShop',
  'updateSupplierShop',
  'querySupplierShop',
  // 'getOverlordTaskStatisticsForPlat',
  'queryShopOverlordBalanceWater',
  'queryOrderOverlordTask',
  'getPosOverlordTaskStatisticsForPlatMp',
  'getOrderOverlordTaskNumForPlatMp',
  'queryShopOverlordBalanceWaterForPlatMp',
  'queryShopOverlordMealList'
]

/** ****** xsd end ************* **/

export default {
  title,
  homeName,
  cookieExpires,
  useI18n
  // baseUrl
}
